<script>
export default {
  name: "TabMenu",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: {
      type: Number,
      default: 0
    },
    disableTab: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      indicatorStyle: {
        width: "0px",
        left: "0px"
      }
    }
  },
  watch:{
    activeTab(){
      this.$nextTick((_new,_old) => {
        this.updateIndicator()
        console.log('lặp')
      })
    }
  },
  methods: {
    changeTab(tab, index) {
      this.$emit("changeTab", tab, index)
    },
    updateIndicator() {
      const elements = this.$refs.tabItem;
      if (!elements || !elements[this.activeTab]) return
      const element = elements[this.activeTab];
      this.indicatorStyle.width = element.offsetWidth + "px"
      this.indicatorStyle.left = element.offsetLeft + "px"
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateIndicator()
    })
    window.addEventListener("resize", this.updateIndicator);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIndicator);
  },
}
</script>

<template>
  <div class="tabs-container">
    <div class="tab" v-for="(tab,index) in tabs" :key="index" :class="{active: activeTab === index,disabled: disableTab}" @click="changeTab(tab,index)" ref="tabItem">
      <slot name="tab" :tab="tab" :index="index">
        {{ tab }}
      </slot>
    </div>
    <div class="indicator" :style="indicatorStyle"></div>
  </div>
</template>

<style scoped>
.tabs-container {
  position: relative;
  width: 100%;
  border-bottom: 2px solid #D6D5D5;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.tab {
  font-size: 16px;
  padding-bottom: 5px;
  cursor: pointer;
}

.active {
  color: #0066FF;


}

.indicator {
  position: absolute;
  bottom: -2px;
  background-color: #0066FF;
  height: 2px;
  transition: all 0.3s ease;
}

.disabled {
  pointer-events: none; /* không cho click */
  cursor: not-allowed;
}
</style>